export default __webpack_public_path__ + "static/media/1.d36a8cd4.png";